import React, { useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Landing from './components/Landing';

import RegisterBinaryDuels from './pages/Register/BinaryDuels.js';
import RegisterCyberKick from './pages/Register/Cyberkick.js';
import RegisterCyberTrack from './pages/Register/Cybertrack.js';
import RegisterProjectConclave from './pages/Register/Projectconclave.js';
import RegisterNexusQuiz from './pages/Register/Nexusquiz.js';
import RegisterNeonRun from './pages/Register/Neonrun.js';
import RegisterNeonMaze from './pages/Register/Neonmaze.js';
import Registerarduinoforge from './pages/Register/ArduinoForge.js';
import RegisterBgmi from './pages/Register/Bgmipunks.js';
import Certificate from './pages/certificate/Certificate.js';
import MissingRegistration from './pages/certificate/MissingRegistration.js';
import PaymentSuccess from './components/Paymentsucess.js';
import AdminStats from './pages/AdminStats.js';
import AdminMissingClaims from './pages/AdminMissingClaims.js';
import AdminFeedback from './pages/AdminFeedback.js';
import NotFoundPage from './pages/Notfound.js';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

const AppLayout = ({ homeRef }) => {
  const location = useLocation();
  const hideChrome = location.pathname.startsWith('/register/') || location.pathname === '/payment-success';

  return (
    <div className="app-shell">

      {!hideChrome && <Navbar homeRef={homeRef} />}
      <main className="app-main">
        <Routes>
          <Route path="/" element={<Landing homeRef={homeRef} />} />
          <Route path="/register/binaryduels" element={<RegisterBinaryDuels />} />
          <Route path="/register/cyberkick" element={<RegisterCyberKick />} />
          <Route path="/register/cybertrack" element={<RegisterCyberTrack />} />
          <Route path="/register/projectconclave" element={<RegisterProjectConclave />} />
          <Route path="/register/nexusquiz" element={<RegisterNexusQuiz />} />
          <Route path="/register/neonrun" element={<RegisterNeonRun />} />
          <Route path="/register/neonmaze" element={<RegisterNeonMaze />} />
          <Route path="/register/arduinoforge" element={<Registerarduinoforge />} />
          <Route path="/register/bgmipunks" element={<RegisterBgmi />} />
          <Route path="/certificate" element={<Certificate />} />
          <Route path="/claim-certificate" element={<MissingRegistration />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/admin-stats" element={<AdminStats />} />
          <Route path="/admin-missing" element={<AdminMissingClaims />} />
          <Route path="/admin-feedback" element={<AdminFeedback />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      {!hideChrome && (
        <div id="contacts" className="app-footer-wrap">
          <Footer />
        </div>
      )}
    </div>
  );
};

const App = () => {
  const homeRef = useRef();

  return (
    <Router>
      <ScrollToTop />
      <AppLayout homeRef={homeRef} />
    </Router>
  );
};

export default App;
